import React from 'react';
import PropTypes from 'prop-types';
import template from '../../../../templates/Stones/AssignPricing/PricingPresets/algorithmPresets.rt';
import { connect } from 'react-redux';
import { getPricingAlgorithmIcons } from '../../../../utilities/helpers';
import * as pricingPresetPages from '../../../../constants/pricingPresets';
import * as actions from '../../../../actions';
import {AccessRights} from '../../../../schemas/accessRightsModel';

function mapStateToProps(state, props) {
  return {
    presets: state.pricingPreset.presets,
    selected: state.pricingPreset.selectedPreset,
    AR: AccessRights.get(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectPreset: (preset) => dispatch(actions.pricingPresets.setSelected(preset)).catch(console.error)
  };
}

class algorithmPresets extends React.Component {
  render = template;
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selectedPreset
    };
  }

  /**
   * Select preset
   * @param {object} preset
   */
  selectPreset = (preset) => {
    this.setState({selected: preset});
    if(this._selectTimeout) window.clearTimeout(this._selectTimeout);
    this._selectTimeout = window.setTimeout(() => this.props.selectPreset(preset), 500);
  }

  getBlanks = () => {
    let blankAmount = 5 - this.props.presets.length
      , blanks = [];
    for(var i = 0; i < blankAmount; i++) {
      blanks.push(i);
    }
    return blanks;
  }
}

algorithmPresets.propTypes = {
  toPage: PropTypes.func.isRequired
};

const AlgorithmPresets = connect(mapStateToProps, mapDispatchToProps)(algorithmPresets);

export default AlgorithmPresets;
